import Swiper from 'swiper';
import { A11y, Autoplay, EffectFade, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';

/** 自動再生の間隔とフェードの長さ（ms） */
const AUTOPLAY_DELAY = 5000;
const FADE_DURATION = 1600;

/**
 * トップページのメインビジュアル。
 * 実績を最大 5 件フェードで自動再生し、「1/5」のカウンターと
 * タイトル下のプログレスバー（--fv-progress）を更新する。
 */
export const initHeroSlider = () => {
  const target = document.querySelector('.js-fv-slider');
  if (!target) return null;

  const setProgress = (value) => {
    target.style.setProperty('--fv-progress', String(value));
  };

  // スライドが 1 枚のときは自動再生が動かないので、線は出したままにする
  if (target.querySelectorAll('.swiper-slide').length < 2) {
    setProgress(1);
  }

  return new Swiper(target, {
    modules: [A11y, Autoplay, EffectFade, Pagination],
    loop: target.querySelectorAll('.swiper-slide').length > 1,
    effect: 'fade',
    fadeEffect: { crossFade: true },
    speed: FADE_DURATION,
    autoplay: { delay: AUTOPLAY_DELAY, disableOnInteraction: false },
    pagination: {
      el: '.js-fv-counter',
      type: 'fraction',
      renderFraction: (currentClass, totalClass) =>
        `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`,
    },
    a11y: { enabled: true },
    on: {
      // 自動再生の残り時間（1 → 0）を伸びぐあい（0 → 1）に変換する
      autoplayTimeLeft: (swiper, time, progress) => setProgress(1 - progress),
      autoplayStop: () => setProgress(1),
    },
  });
};

/**
 * 旧デザインのページ（page-en など）で使っている素の .swiper 用。
 * 新しいメインビジュアルに置き換わったら削除してよい。
 */
export const initLegacySlider = () => {
  const target = document.querySelector('.swiper:not(.js-fv-slider)');
  if (!target) return null;

  return new Swiper(target, {
    modules: [Autoplay, EffectFade],
    loop: true,
    effect: 'fade',
    speed: 2000,
    autoplay: { delay: 3000, disableOnInteraction: false },
    a11y: { enabled: true },
  });
};
